
import dataFetch from '@/utils/request'

// 获取资讯、品牌活动文章
export function getArticleList(data) {
  return dataFetch('/service/pgc.listArticleByCategory', data, {
    method: 'post'
  })
}

// 获取文章详情
export function getArticleDetail(data) {
  return dataFetch(`/service/pgc.articleDetail?articleId=${data}`, null, {
    method: 'get',
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js